<markant-expansion-panel>
  <markant-expansion-panel-item
    colorMode="medium"
    size="medium"
    expandIconPosition="right"
    (itemExpandedChange)="emitItemExpandedChange($event.detail)"
  >
    <h6
      slot="markant-expansion-panel-item-header"
      class="calculation-parameter-headline"
    >
      {{ 'booking.overview.calculationParameters' | transloco }}
    </h6>
    <div
      slot="markant-expansion-panel-item-content"
      class="calculation-parameter-content"
    >
      <ul class="calculation-parameter-list">
        @for (parameter of calculationParameters; track $index) {
          <li>{{ parameter }}</li>
        }
      </ul>
    </div>
  </markant-expansion-panel-item>
</markant-expansion-panel>
